import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#6E84A1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m1.546 5.132 3.908 2.605c.92.613 1.38.92 1.878 1.04.439.105.897.105 1.336 0 .498-.12.958-.427 1.878-1.04l3.908-2.605M3.841 13.02h8.318c.803 0 1.205 0 1.512-.157.27-.137.49-.356.627-.626.156-.307.156-.709.156-1.512v-5.45c0-.803 0-1.205-.156-1.512a1.43 1.43 0 0 0-.627-.626c-.307-.157-.709-.157-1.512-.157H3.841c-.803 0-1.205 0-1.512.157-.27.137-.49.356-.627.626-.156.307-.156.709-.156 1.512v5.45c0 .803 0 1.205.156 1.512.138.27.357.489.627.626.307.157.708.157 1.512.157" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }